export default __webpack_public_path__ + "static/screen-game-0250df4e8019f0c98dc8d2f020e5a002.mp4";